module.exports = __webpack_public_path__ + "img/go.401f2002.png";